import {
  getProductsById,
  getCombinationByIds,
  searchProducts,
} from "../services/legoService";

export type Config  = Record<string, Record<string, any>>

export interface ComponentIdMaps {
  [key: string]: string[];
}

export enum IDataRequestType {
  discover = "discover",
  product_id = "product_id",
  combination_id = "combination_id",
}
export interface UpdateComponetsProtocol {
  combinationListById: ComponentIdMaps;
  productByIds: ComponentIdMaps;
  queue: { component: string; type: IDataRequestType }[];
}

export interface IFetchIdsSearchRequest {
  componentIdMaps: ComponentIdMaps;
  config: Config;
}

export interface IDiscoverSearchRequest {
  component: string;
  config: Config;
}

const getProductSearchQuery = (componentConfig) => {
  const {
    tags,
    merchantList,
    brandList,
    discountRange,
    priceList,
    categoryIds,
    excludedBrands,
    excludedCategories,
    labels,
    excludedTags,
    sortType,
    promoId,
    q,
  } = componentConfig.config || {};
  return {
    id: componentConfig.id,
    tg: tags || [],
    ntg: excludedTags || [],
    m: merchantList,
    b: brandList,
    dr: discountRange
      ? `${(10 - discountRange[1]) * 10}-${(10 - discountRange[0]) * 10}`
      : null,
    prs: priceList ? `${priceList[0] * 100}-${priceList[1] * 100}` : null,
    cids: categoryIds,
    nb: excludedBrands,
    ncids: excludedCategories,
    l2: labels,
    f: 0,
    t: componentConfig.config.maxProductNum || 20,
    s: sortType || "sales",
    promoId: promoId,
    q,
  };
};

const getIds = (componentIdMaps: ComponentIdMaps): string[] => {
  if (componentIdMaps) {
   return Object.entries(componentIdMaps).reduce((init, [componet, ids]) => {
      return init.concat(ids);
    }, [] as string[]);
  }
  return [];
};

export const updateProductByIds = (
  componentIdMaps: ComponentIdMaps,
  config: Config
): Promise<any> =>
  getProductsById(getIds(componentIdMaps))
    .then((res) => {
      if (res.data?.length) {
        const resIdDataMaps = res.data.reduce((init, data) => {
          if (data?.product?.id) {
            init[data.product.id] = data;
          }
          return init;
        }, {} as Record<string, any>);

        const dataMap = {};

        Object.entries(componentIdMaps).forEach(([key, value]) => {
          const isFilterSellOut = config[key]?.config?.filterSellOut;
          dataMap[key] = {
            products: value?.reduce((init, pid) => {
              const pd = resIdDataMaps[pid];
              if (pd) {
                if (isFilterSellOut) {
                  pd.product.inventoryStatus === "AVAILABLE" && init.push(pd);
                } else {
                  init.push(pd);
                }
              }
              return init;
            }, [] as any[]),
          };
        });
        return dataMap;
      }
    })
    .catch((err) => {
      console.error(err);
      return {};
    });

export const updateCombinationByIds = (
  componentIdMaps: ComponentIdMaps,
): Promise<any> =>
  getCombinationByIds(getIds(componentIdMaps)).then((res) => {
    const resIdMap = res.data.waterDrops?.reduce((init, com) => {
      com.wdId && (init[com.wdId] = com);
      return init;
    }, {});

    return Object.entries(componentIdMaps).reduce((init, [key, value]) => {
      init[key] = {
        combinations: value.reduce((init, item) => {
          const comb = resIdMap[item];
          comb && init.push(comb);
          return init;
        }, [] as any[]),
      };
      return init;
    }, {});
  });

export const updateProdcutBySearch = (
  component: string,
  config: Config
): Promise<any> =>
  searchProducts(getProductSearchQuery(config[component]) || {})
    .then((res) => {
      if (res && res.data && res.data.products.length > 0) {
        const updateProducts = res.data.products.reduce((init, product) => {
          if (product?.type === "PRODUCT") {
            const pd = product.searchProduct;
            pd.product.inventoryStatus === "AVAILABLE" && init.push(pd);
          }
          return init;
        }, [] as any[]);
        return {
          [component]: {
            products: updateProducts,
          },
        };
      } else {
        return {
          [component]: {
            products: [],
          },
        };
      }
    })
    .catch(() => {
      return {
        [component]: {
          products: [],
        },
      };
    });


export type IDataRequest =
  | {
      type: IDataRequestType.product_id | IDataRequestType.combination_id
      request: IFetchIdsSearchRequest;
    }
  | {
      type: IDataRequestType.discover;
      request: IDiscoverSearchRequest;
    };

export interface DataScheduler {
  queue: IDataRequest[]
}
